import React from "react";
import Button, { ButtonProps } from "@/components/reusable/Button";

interface SimpleTextPageProps {
  data: {
    text: string;
    buttons?: any[];
  };
}

export default function SimpleTextPage({
  data: { text, buttons },
}: SimpleTextPageProps) {
  const blockquoteContentMatch = text.match(
    /<blockquote[^>]*>([\s\S]*?)<\/blockquote>/i
  );
  const blockquoteContent = blockquoteContentMatch
    ? blockquoteContentMatch[1]
    : undefined;

  const blockquoteText = blockquoteContent
    ? blockquoteContent.replace(/<[^>]+>/g, "").trim()
    : undefined;

  const sectionId = blockquoteText && blockquoteText.replace(/\s+/g, "-");

  return (
    <div className="bg-accent-color-three flex justify-center items-start py-16 px-4">
      <div className="desktop:max-w-[50vw] w-full">
        <div
          className="prose prose-invert"
          style={{
            color: "#fff",
          }}
        >
          <style>
            {`
              .simple-text-page-table-section table,
              .simple-text-page-table-section th,
              .simple-text-page-table-section td {
                border: 1px solid #f9f9f9 !important;
              }
            `}
          </style>
          {blockquoteText ? (
            <section
              id={sectionId?.replaceAll(/[^a-zA-Z0-9-_]/g, "-")}
              data-name={blockquoteText}
            >
              <div
                dangerouslySetInnerHTML={{ __html: text }}
                className="
                  font-sans simple-text-page-table-section
                  [&_h1]:text-3xl [&_h1]:text-secondary-light [&_h1]:mb-8 [&_h1]:font-normal
                  [&_h2]:text-lg [&_h2]:uppercase [&_h2]:tracking-[0.15em] [&_h2]:mb-4 [&_h2]:mt-8 [&_h2]:text-accent-color-two-light
                  [&_h3]:font-bold [&_h3]:text-lg
                  [&_h4]:font-bold [&_h4]:text-md
                  [&_p]:mb-6 [&_p]:text-lg [&_p]:text-[#fff] [&_p]:font-light
                  [&_li]:mb-6 [&_li]:text-lg [&_li]:text-[#fff] [&_li]:font-light
                  [&_ul]:mb-6 [&_li]:mb-2
                  [&_strong]:font-bold [&_b]:font-bold
                "
              />
            </section>
          ) : (
            <div
              dangerouslySetInnerHTML={{ __html: text }}
              className="
                font-sans simple-text-page-table-section
                [&_h1]:text-3xl [&_h1]:text-secondary-light [&_h1]:mb-8 [&_h1]:font-normal
                [&_h2]:text-lg [&_h2]:uppercase [&_h2]:tracking-[0.15em] [&_h2]:mb-4 [&_h2]:mt-8 [&_h2]:text-accent-color-two-light
                [&_h3]:font-bold [&_h3]:text-lg
                [&_h4]:font-bold [&_h4]:text-md
                [&_p]:mb-6 [&_p]:text-lg [&_p]:text-[#fff] [&_p]:font-light
                [&_li]:mb-6 [&_li]:text-lg [&_li]:text-[#fff] [&_li]:font-light
                [&_ul]:mb-6 [&_li]:mb-2
                [&_strong]:font-bold [&_b]:font-bold
              "
            />
          )}
        </div>
        {buttons && buttons.length > 0 && (
          <div className="flex gap-4 mt-8 flex-wrap w-full justify-between">
            {buttons.map((btn, i) => (
              <Button key={i} {...btn.item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
